/* istanbul ignore file */
import { MessagingClient as AgodaMessagingClient } from '@agoda/messaging-client';
import messagingClientWorkerUrl from '@agoda/messaging-client/dist/messaging-client-worker.js';
import messagingClientPolyFillWorkerUrl from '@agoda/messaging-client/dist/messaging-client-polyfills';

const workerUrlString: string = messagingClientWorkerUrl.default
    ? messagingClientWorkerUrl.default
    : messagingClientWorkerUrl;
const polyfillsUrlString: string = messagingClientPolyFillWorkerUrl.default
    ? messagingClientPolyFillWorkerUrl.default
    : messagingClientPolyFillWorkerUrl;

export module MessagingClient {
    const environment = __ENV__ === 'prod' ? 'production' : 'development';

    export const instance = AgodaMessagingClient.instantiate({
        apiKey: 'FeMessaging',
        workerUrl: workerUrlString,
        polyfillsUrl: polyfillsUrlString,
        mode: environment,
    });
}
